<template>
    <div >
        <template v-if="article.id">
            <div class="article-header" >
                <h1 v-html="article.name"></h1>
                <h2 v-if="issueTime"><Icon type="ios-clock-outline" size="16" />{{issueTime}}</h2>
            </div>
            <froalaView v-model="article.content"></froalaView>
            <ul class="file-list-wrap">
                <li v-for="(item,index) in files">
                    <a :href="item.link" target="_blank">{{index + 1}}. {{item.name}}</a>
                </li>
            </ul>
        </template>
        <div style="text-align: center;padding: 30px 0 20px">
            <Button type="primary" @click="toBack" style="width: 100px">返回</Button>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .article-header{
        margin: 0 auto 20px;
        text-align: center;
        & >h1{
            font-size: 20px;
            border-bottom: 1px solid rgb(234,234,234);
            padding: 10px;
        }
        & >h2{
            font-size: 16px;
            font-weight: normal;
            padding: 5px;
        }
    }
    .file-list-wrap{
        margin: 20px 0;
        list-style: none;
        & li{
            line-height: 30px;
            font-size: 14px;
        }
    }
</style>
<script>
    import news from '../channel/News'
    import service from '../../common/service'
    import moment from 'moment'

    const articleService = new service({baseUrl:'/web/article/'});

    export default {
        data() {
            return {
                template:'news',
                article:{content:''},
                files:[]
            }
        },
        computed:{
            issueTime(){
                if(this.article.issueTime){
                    return moment(this.article.issueTime).format("YYYY-MM-DD");
                }
                return '';
            }
        },
        props:['articleId'],
        watch:{
          'articleId'(v){
              this.$nextTick(()=>{
                  this.loadContent();
              })
          }
        },
        components: {news},
        mounted(){
            if(this.articleId){
                this.loadContent();
            }
        },
        methods:{
            loadContent(){
                let self = this;
                articleService.get(`${this.articleId}`).then((res)=>{
                    const json = res.data;
                    if(json.success){
                        self.article = {...json.data};
                        self.files = [...json.extra.files];
                    }
                })
            },
            toBack(){
                if (window.history.length <= 1) {
                    this.$router.push("/");
                }else{
                    this.$router.back();
                }
            }
        }
    }
</script>
